<template>
    <div class="newsCategoryNav">
        <button type="button" v-if="newsCategories.length > 1" class="btn-plain" :class="{'current': categorie.toLowerCase() === currentCategory}" 
                v-for="categorie in newsCategories"
                @click.prevent="emitChangeCategory(categorie.toLowerCase())"> {{categorie}} </button>
    </div>
</template>

<script setup lang="ts">
    import { onMounted } from 'vue';
import { useNewsOverview } from './composables/UseNewsOverview';
import { emitterInstance } from '@/classes/emitter';

    const props = defineProps({
        currentCategory: {
            type: String,
            required: true,
        }
    });
    const { newsCategories,
            initCategories,
        } = useNewsOverview();

    onMounted(async()=>{
        await initCategories();
    })

    const emitChangeCategory = (category:string)=>{
        emitterInstance.emit("changeCategory", category);
    }
</script>